import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { push as pushToHistory } from 'redux-first-history';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import GIButton from '../../../components/common/button/GIButton';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

// Components
import TagItems from './TagItem';
import AutocompleteSearch from '../../../components/common/autocomplete-search/AutocompleteSearch';

// Action creator
import { assigneesActionCreators } from '../../../actions/ticketMgmtPortal/ticketMgmtPortalActionCreators';

// type
import { ITag, IManageTags } from './manageWorkgroup.interface';

function ManageTags(props: IManageTags) {
    const [isEditTag, setEditTag] = useState(false);
    const [selectedTags, setSelectedTags] = useState<ITag[]>([...props.items]);
    const { id } = useParams();

    const {
        items,
        setUpdateEvent,
        saveWorkgroupTags,
        tagList,
    } = props || '';

    useEffect(() => {
        if (items?.length > 0) {
            setSelectedTags([...items]);
        } else {
            setSelectedTags([]);
        }
    }, [items]);


    const filterTags = (tagValue: string) => {
        const filteredTags = tagList.filter((tag) =>
            tag.name.toLowerCase().includes(tagValue.toLowerCase()),
        );
        return filteredTags;
    };

    const fetchResults = (debounceSearchValue: string) => {
        if (!debounceSearchValue) {
            return tagList;
        };
        const response = filterTags(debounceSearchValue);
        return response.length > 0 ? response : [];
    };

    const deleteItem = (id: number) => {
        setSelectedTags((items) => items.filter((item) => item.id !== id));
    };

    const cancelModifiedTags = () => {
        setEditTag(false);
        setSelectedTags([...items]);
    };

    const handleSave = async () => {
        const payload = {
            workGroupId: id,
            tags: selectedTags.map((tag) => tag.id.toString()),
        };
        const response = await saveWorkgroupTags(payload);
        if (response) {
            setUpdateEvent(true);
            setEditTag(false);
        }
    };

    const getModifiedReadView = () => {
        if (isEditTag) {
            return (
                <>
                    <div className="desktop:grid-col-6 text-right" data-testid="manage-tags-edit-controls-container-div">
                        <span className="controls" data-testid="manage-tags-edit-controls-container-span">
                            <GIButton
                                id="cancelModifiedTags"
                                labelId={'button.cancel'}
                                variant="secondary"
                                dataTestId="manage-tags-edit-cancel-button"
                                onClickHandler={() => cancelModifiedTags()}
                            />
                            <GIButton
                                id="saveChanges"
                                labelId={'button.save_changes'}
                                dataTestId='manage-tags-edit-save-button'
                                onClickHandler={() => handleSave()}
                            />
                        </span>
                    </div>
                    <div className="desktop:grid-col-12 ui_main_tags_wrapper" data-testid="manage-tags-edit-autocomplete-controller">
                        <AutocompleteSearch
                            {...{
                                id: 'manage-workgroup-tags-component-autocomplete',
                                setSelectedItems: setSelectedTags,
                                selectedItems: selectedTags,
                                label: 'ticket_management.workgroupTags.autocomplete.label',
                                isClearInputValue: true,
                                isClearApiResults: true,
                                fetchResults,
                                debounceSearchTime: 300,
                                minSearchQueryLength: 1,
                                loadDataOnInit: true,
                            }}
                        />
                        <TagItems
                            deleteItem={deleteItem}
                            items={selectedTags}
                            isDeletable={true}
                        />
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div className="desktop:grid-col-6 text-right" data-testid="manage-tags-add-container">
                        <GIButton
                            id="editManageTagsEdit"
                            dataTestId="manage-tags-add-edit-button"
                            labelId={'button.edit'}
                            onClickHandler={() => setEditTag(true)}
                            iconPlacement="start"
                            variant="secondary"
                            icon={<FontAwesomeIcon icon={faEdit} />}
                        />
                    </div>
                    <div className="desktop:grid-col-12 ui_main_tags_wrapper" data-testid="manage-tags-add-list">
                        <TagItems
                            {...{
                                deleteItem,
                                items,
                                isDeletable: false,
                            }}
                        />
                    </div>
                </>
            );
        }
    };

    return (
        <div
            className="grid-row margin-bottom-2em margin-top-2em"
            id="manage-tags"
            data-testid="manage-tags-edit-main-container"
        >
            <div className="desktop:grid-col-6 text-left" data-testid="manage-tags-edit-heading">
                <h3 data-testid="manage-tags-edit-h3">
                    <FormattedMessage id="ticket_management.workgroupTags.header.label" />
                </h3>
            </div>

            {getModifiedReadView()}
        </div>
    );
}

export default connect(null, {
    ...assigneesActionCreators,
    pushToHistory,
})(ManageTags);